module.exports = __webpack_public_path__ + "img/card-secure.703303a5.svg";